import React from "react";
import { Link } from "react-router-dom";

import Divider from "./divider";

export default function ManageTendersNav(props) {
  const { secondaryId } = props;

  return (
    <>
      <div className="settings_menu">
        <h4 className="my-3">Tender Offer</h4>
        <Divider
          style={{
            position: "relative",
            left: 0,
            marginBottom: 16,
            height: 2,
            marginRight: 4,
          }}
        />

        <ul>
          <div className="sidemenu">
            <li className="nav-item">
              <Link
                to={`/org/dashboard`}
                className={
                  "nav-link " +
                  (document.location.href.includes("org/dashboard")
                    ? "active"
                    : "")
                }
              >
                <i className="la la-chart-bar"></i>
                <span>Overview</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to={`/org/tenders/manage/${secondaryId}/participants`}
                className={
                  "nav-link " +
                  (document.location.href.includes("participants")
                    ? "active"
                    : "")
                }
              >
                <i className="la la-user-circle"></i>
                <span>Manage Participants</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to={`/org/tenders/manage/${secondaryId}/orders`}
                className={
                  "nav-link " +
                  (document.location.href.includes("orders") ? "active" : "")
                }
              >
                <i className="la la-list"></i>
                <span>View Orders</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to={`/org/tenders/manage/${secondaryId}/dataroom`}
                className={
                  "nav-link " +
                  (document.location.href.includes("dataroom") ? "active" : "")
                }
              >
                <i className="la la-file-alt"></i>
                <span>Dataroom</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to={`/org/tenders/manage/${secondaryId}/analytics`}
                className={
                  "nav-link " +
                  (document.location.href.includes("analytics") ? "active" : "")
                }
              >
                <i className="la la-chart-area"></i>
                <span>Analytics</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to={`/org/tenders/manage/${secondaryId}/modeling`}
                className={
                  "nav-link " +
                  (document.location.href.includes("modeling") ? "active" : "")
                }
              >
                <i className="la la-chart-pie"></i>
                <span>Modeling</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to={`/org/tenders/manage/${secondaryId}/communications`}
                className={
                  "nav-link " +
                  (document.location.href.includes("communications")
                    ? "active"
                    : "")
                }
              >
                <i className="la la-envelope"></i>
                <span>Communications</span>
              </Link>
            </li>
          </div>
        </ul>
      </div>
    </>
  );
}
